import { gql } from '@apollo/client';

export interface GetPendingRouteAggregateSummaryResponse {
  getPendingRouteAggregateSummary: {
    pendingPlanningParcelCount: number | null;
    newToWarehouseParcelCount: number | null;
    returnRedispatchParcelCount: number | null;
    publishedParcelCount: number | null;
  } | null;
}

export interface GetPendingRouteAggregateSummaryVariables {
  request: {
    warehouseId: number;
    dspId?: number | null;
  };
}

export const GET_PENDING_ROUTE_AGGREGATE_SUMMARY = gql`
  query GetPendingRouteAggregateSummary($request: GetPendingRouteAggregateSummaryRequestInput!) {
    getPendingRouteAggregateSummary(request: $request) {
      pendingPlanningParcelCount
      newToWarehouseParcelCount
      returnRedispatchParcelCount
      publishedParcelCount
    }
  }
`;

export const GET_PENDING_ROUTE_AGGREGATE_SUMMARY_FOR_DSP = gql`
  query GetPendingRouteAggregateSummaryForDsp($request: GetPendingRouteAggregateSummaryRequestInput!) {
    getPendingRouteAggregateSummaryForDsp(request: $request) {
      pendingPlanningParcelCount
      newToWarehouseParcelCount
      returnRedispatchParcelCount
      publishedParcelCount
    }
  }
`;

export interface OrderPoolPageItem {
  orderId: number | null;
  trackingNumber: string | null;
  overallStatus: number | null;
  areaName: string | null;
  bagNumber: string | null;
  dspName: string | null;
  hubArrivalTime: string | null;
  whsArrivalTime: string | null;
}

export interface ListOrderPoolPageResult {
  content: OrderPoolPageItem[];
  total: number;
  pageNum: number;
  pageSize: number;
}

export interface ListOrderPoolPageResponse {
  listOrderPoolPage: ListOrderPoolPageResult;
}

export interface ListOrderPoolPageVariables {
  request: {
    warehouseId: number;
    trackingNumbers?: string[] | null;
    bagNumbers?: string[] | null;
    hubArrivalTimeStart?: string | null;
    hubArrivalTimeEnd?: string | null;
    whsArrivalTimeStart?: string | null;
    whsArrivalTimeEnd?: string | null;
    /** 单区域筛选，已被 areaIds 取代；后端保留该字段用于兼容旧前端 */
    areaId?: number | null;
    /** 多区域筛选（取并集）；有值时后端优先用它 */
    areaIds?: number[] | null;
    parcelType?: number | null;
    overallStatus?: number | null;
    dspId?: number | null;
    pageNum?: number | null;
    pageSize?: number | null;
  };
}

export const LIST_ORDER_POOL_PAGE_FOR_DSP = gql`
  query ListOrderPoolPageForDsp($request: ListOrderPoolPageRequestInput!) {
    listOrderPoolPageForDsp(request: $request) {
      content {
        orderId
        trackingNumber
        overallStatus
        areaName
        bagNumber
        dspName
        hubArrivalTime
        whsArrivalTime
      }
      total
      pageNum
      pageSize
    }
  }
`;

export const LIST_ORDER_POOL_PAGE = gql`
  query ListOrderPoolPage($request: ListOrderPoolPageRequestInput!) {
    listOrderPoolPage(request: $request) {
      content {
        orderId
        trackingNumber
        overallStatus
        areaName
        bagNumber
        dspName
        hubArrivalTime
        whsArrivalTime
      }
      total
      pageNum
      pageSize
    }
  }
`;
